import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { Button } from '../../../../components/ui/Button';
import { Input } from '../../../../components/ui/Input';
import { Select } from '../../../../components/ui/Select';
import { generateUniqueLinkCode, suggestUsername, hashPassword } from '../../../../accounts';
import type { AccountsState } from '../../../../accounts';
interface AddUserFormProps {
  accounts: AccountsState | undefined;
  store: {
    createAccount: (role: string, options: Record<string, unknown>) => void;
  };
  onClose: () => void;
}
export function AddUserForm({
  accounts,
  store,
  onClose
}: AddUserFormProps) {
  const [newUserRole, setNewUserRole] = useState<'learner' | 'teacher' | 'parent' | 'admin'>('learner');
  const [newUserName, setNewUserName] = useState('');
  const [newUserEmail, setNewUserEmail] = useState('');
  const [newUserSchool, setNewUserSchool] = useState('');
  const [newUserGrade, setNewUserGrade] = useState('6');
  const [newUserPassword, setNewUserPassword] = useState('');
  const handleAddUser = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newUserName.trim()) return;
    if (newUserRole === 'learner') {
      const linkCode = generateUniqueLinkCode(accounts);
      const username = suggestUsername(newUserName.trim());
      const passwordHash = newUserPassword.trim() ? await hashPassword(newUserPassword.trim()) : undefined;
      store.createAccount(newUserRole, {
        displayName: newUserName.trim(),
        email: newUserEmail || undefined,
        grade: parseInt(newUserGrade, 10),
        linkCode,
        username,
        passwordHash
      });
    } else {
      store.createAccount(newUserRole, {
        displayName: newUserName.trim(),
        email: newUserEmail || undefined,
        schoolName: newUserSchool || undefined
      });
    }
    onClose();
  };
  return <form onSubmit={handleAddUser} className="space-y-4" data-id="element-4152">
      <Select label="Rol" value={newUserRole} onChange={e => setNewUserRole(e.target.value as 'learner' | 'teacher' | 'parent' | 'admin')} options={[{
      value: 'learner',
      label: 'Leerling'
    }, {
      value: 'teacher',
      label: 'Docent'
    }, {
      value: 'parent',
      label: 'Ouder'
    }, {
      value: 'admin',
      label: 'Admin'
    }]} data-id="element-4153" />
      <Input label="Naam" type="text" required value={newUserName} onChange={e => setNewUserName(e.target.value)} placeholder="Volledige naam" data-id="element-4154" />
      <Input label="E-mailadres (optioneel)" type="email" value={newUserEmail} onChange={e => setNewUserEmail(e.target.value)} placeholder="email@voorbeeld.nl" data-id="element-4155" />
      {newUserRole === 'teacher' && <Input label="School" type="text" value={newUserSchool} onChange={e => setNewUserSchool(e.target.value)} placeholder="Naam van de school" data-id="element-4156" />}
      {newUserRole === 'learner' && <Select label="Groep" value={newUserGrade} onChange={e => setNewUserGrade(e.target.value)} options={[{
      value: '6',
      label: 'Groep 6'
    }, {
      value: '7',
      label: 'Groep 7'
    }, {
      value: '8',
      label: 'Groep 8'
    }]} data-id="element-4157" />}
      {newUserRole === 'learner' && <Input label="Wachtwoord (optioneel)" type="password" value={newUserPassword} onChange={e => setNewUserPassword(e.target.value)} placeholder="Minimaal 4 tekens" minLength={4} icon={<KeyRound className="w-4 h-4" data-id="element-4159" />} helperText="Leerling kan ook inloggen met koppelcode (wordt automatisch gegenereerd)." data-id="element-4158" />}
      <div className="pt-4 flex justify-end gap-2" data-id="element-4160">
        <Button type="button" variant="secondary" onClick={onClose} data-id="element-4161">
          Annuleren
        </Button>
        <Button type="submit" data-id="element-4162">Aanmaken</Button>
      </div>
    </form>;
}